module.exports = __webpack_public_path__ + "media/music/piano_chords_1-61507965.mp3";